// If user clicks 'show more' button - show content
const showMoreButton = document.getElementsByClassName('show-more-btn');
const showMoreContent = document.getElementsByClassName('show-more-content');
const showLessButton = document.getElementsByClassName('show-less-btn');

for (var i = 0; i < showMoreButton.length; i++) {
  showMoreButton[i].onclick = function () {
    var setClasses = !this.classList.contains('hidden');
    setClass(showMoreButton, 'hidden', 'remove');
    setClass(showMoreContent, 'open', 'remove');
    setClass(showLessButton, 'hidden', 'remove');

    if (setClasses) {
      this.classList.toggle('hidden');
      this.previousElementSibling.classList.toggle('open');
    }
  };
}

// If user clicks 'show less' button - hidden content
for (var i = 0; i < showLessButton.length; i++) {
  showLessButton[i].onclick = function () {
    setClass(showMoreButton, 'hidden', 'remove');
    this.parentElement.classList.toggle('open');
  };
}

function setClass(els, className, fnName) {
  for (var i = 0; i < els.length; i++) {
    els[i].classList[fnName](className);
  }
}

